import { render, staticRenderFns } from "./IT.vue?vue&type=template&id=88983a72&scoped=true&"
import script from "./IT.vue?vue&type=script&lang=js&"
export * from "./IT.vue?vue&type=script&lang=js&"
import style0 from "./IT.vue?vue&type=style&index=0&id=88983a72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88983a72",
  null
  
)

export default component.exports